<template>
  <div :class="{ disabled: disabled, loading: isLoading }" class="footer">
    <content-padding v-if="extraFloatingButton">
      <ck-button
        :action="extraFloatingButton.action"
        class="secondary floating-button"
        @click.native="$emit('floating-button-action')"
      />
    </content-padding>

    <div class="footer-body" @click="handleAction()">
      <div v-if="!isLoading" class="title">
        <h3>{{ title }}</h3>
      </div>
      <div v-if="isLoading" class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPadding from '../shared-layout/ContentPadding.vue'
import CkButton from './CkButton.vue'
export default {
  components: {
    CkButton,
    ContentPadding
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    extraFloatingButton: {
      type: Object,
      default: null
    },
    isLoading: Boolean
  },
  data() {
    return {
      isLocked: false
    }
  },
  mounted() {
    this.$store.commit('components/setHasFooter', true)
  },
  beforeDestroy() {
    this.isLocked = false
    this.$store.commit('components/setHasFooter', false)
  },
  methods: {
    handleAction() {
      if (this.isLocked || this.disabled) return
      this.isLocked = true
      this.$emit('footer-action')
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

@footer-space: @space-m+ @space-xxs;
@footer-bg: @btn-proceed-bg;
@footer-text: @btn-proceed-text;

@footer-disabled-text: @btn-proceed-disabled-text;

@footer-loader-size: 36px;

.footer {
  -webkit-overflow-scrolling: touch;
  position: fixed;
  width: 100vw;
  bottom: 0px;
  left: 0;
  top: auto;
  z-index: 99999;
}

.footer-body {
  .lh-display(flex);
  .lh-align-items(flex-start);
  .shadow(0, -3px, 8px, 5, @grey-dark);
  height: @footer-height;
  padding-top: @footer-space;
  background-color: @footer-bg;

  > div {
    .lh-flex(1);
    .lh-display(flex);
    .lh-justify-content(center);

    &:first-child span {
      margin-right: auto;
    }
    &:last-child span {
      margin-left: auto;
    }
  }
}
.floating-button {
}

.title {
  color: @footer-text;
  line-height: 18px;
  text-transform: uppercase;
}

.footer.disabled {
  .title {
    color: @footer-disabled-text;
  }
}

// Loader
.footer-body {
  .lds-ring {
    width: @footer-loader-size;
    height: @footer-loader-size;
    right: 10px;
    top: auto;
    bottom: auto;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 22px;
    height: 22px;
    margin: 6px;
    border: 3px solid @footer-text;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: @footer-text transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
